import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

const CUSTOM_ROUTES = {
  ADD_PING: 'add-ping',
};

const useCustomEditView = () => {
  const { '*': path } = useParams();

  const isCustomView = useMemo(() => {
    const isMatchingRoute = (route: string) => {
      const routeParts = route.split('/');
      const pathParts = path?.split('/');

      return routeParts.length === pathParts?.length
        && routeParts.every(
          (part, i) => part.startsWith(':') || part === pathParts[i],
        );
    };

    const matched = Object.values(CUSTOM_ROUTES).some(isMatchingRoute);
    return matched;
  }, [path]);

  return {
    isCustomView,
  };
};

export default useCustomEditView;
